import React from 'react';
import { Row, Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap';

const LocationPicker = ({ latitude, longitude, onChange, required = false, errors = {} }) => {
  const handleChange = (field, value) => {
    const numValue = value === '' ? '' : parseFloat(value);
    onChange({
      latitude: field === 'latitude' ? numValue : latitude,
      longitude: field === 'longitude' ? numValue : longitude,
    });
  };

  const validateLatitude = (val) => {
    if (val === '' || val === null || val === undefined) {
      return required ? 'Latitude is required' : null;
    }
    const num = parseFloat(val);
    if (isNaN(num) || num < -90 || num > 90) {
      return 'Latitude must be between -90 and 90';
    }
    return null;
  };

  const validateLongitude = (val) => {
    if (val === '' || val === null || val === undefined) {
      return required ? 'Longitude is required' : null;
    }
    const num = parseFloat(val);
    if (isNaN(num) || num < -180 || num > 180) {
      return 'Longitude must be between -180 and 180';
    }
    return null;
  };

  const latError = errors.latitude || validateLatitude(latitude);
  const lngError = errors.longitude || validateLongitude(longitude);

  return (
    <Row>
      <Col md={6}>
        <FormGroup>
          <Label for="latitude">
            Latitude {required && <span className="text-danger">*</span>}
          </Label>
          <Input
            id="latitude"
            name="latitude"
            type="number"
            step="any"
            min="-90"
            max="90"
            value={latitude === '' || latitude === null ? '' : latitude}
            onChange={(e) => handleChange('latitude', e.target.value)}
            invalid={!!latError}
            required={required}
          />
          {latError && <FormFeedback>{latError}</FormFeedback>}
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label for="longitude">
            Longitude {required && <span className="text-danger">*</span>}
          </Label>
          <Input
            id="longitude"
            name="longitude"
            type="number"
            step="any"
            min="-180"
            max="180"
            value={longitude === '' || longitude === null ? '' : longitude}
            onChange={(e) => handleChange('longitude', e.target.value)}
            invalid={!!lngError}
            required={required}
          />
          {lngError && <FormFeedback>{lngError}</FormFeedback>}
        </FormGroup>
      </Col>
    </Row>
  );
};

export default LocationPicker;
